import { Component, OnInit, ViewChild, Input, ChangeDetectorRef, NgZone } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';
import { environment } from '../../../environments/environment';
import * as firebase from 'firebase';
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit {
  result: any[] = [];
  user: any;
  isActive: boolean;
  isPageChanged: boolean;
  public isMouseOver: boolean;
  searchBar: boolean;
  subs = new Subscription();
  searchTerm = "";
  welcomeSearch = false;
  database = firebase.database();
  storagePath: string;
  @ViewChild("searchInput") searchInput: NgModel;
  @Input() placeholder = "Arçelik Kahve Makinesi";
  @Input() page;
  isMobile: boolean;
  constructor(
    private elasticSearchService: ElasticSearchService,
    private router: Router,
    private zone: NgZone,
    private _cd: ChangeDetectorRef,
    private media: MediaMatcher) {
    this.storagePath = environment.storagePath;
    this.isMobile = this.media.matchMedia('(max-width:600px)').matches;
  }

  ngOnInit() {


    if (this.router.url === '/') {


      this.searchBar = true;
    }
    else {

      this.searchBar = false;
    }

    this.subs.add(this.router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        if (event.url.indexOf("search") == -1) {
          this.searchTerm = "";
        }
      }
    }))
  }

  goTo(search) {
    this.isMouseOver = false;
    this.inputBlur();
    let goTo = search.type == 'user' || search.type == 'brand' || search.type == 'product' ? search.uniqueName : search.type + "/" + search.uniqueName;
    this.zone.run(() => this.router.navigate([`/${goTo}`]));

  }

  seeAllResult() {
    this.isMouseOver = false;
    this.inputBlur();
    this.router.navigate(['/search'], { queryParams: { searchTerm: this.searchTerm } });
  }

  navigate() {
    this.router.navigate(['/' + this.user.username]);
  }

  inputKeyUp(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      this.isPageChanged = true;
      return
    }

    if (this.searchTerm.length == 0) {
      this.result = [];
      return;
    }
    if (this.searchTerm.length > 2) {
      let searchTerm = this.searchTerm.replace(/\s|@|,|'|\.|\#/g, '').toLowerCase().trim();
      this.subs.add(this.elasticSearchService.searchBy("SearchTerm", { "searchTerm": searchTerm })
        .subscribe((hits: any[]) => {
          this.result = hits
          this.isActive = !this.isPageChanged && this.result.length > 0;
          this.isPageChanged = false;
          this._cd.markForCheck();
        }));
    }
  }
  inputBlur() {
    if (!this.isMouseOver) {
      this.isActive = false;
      this.result = [];
    }
  }
  inputFocus() {
    if (this.searchTerm.length > 2) {
      this.isActive = true;
    }
  }
  suggestionMouseOver() {
    this.isMouseOver = true;
  }
  suggestionMouseOut() {
    this.isMouseOver = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/searchbar/searchbar.component.ts